function previewSender() {
  const senderForm = document.querySelector('#sender-form')

  if (senderForm) {
    const senderName = senderForm.querySelector('[name="account[sender_name]"]')
    const senderEmail = senderForm.querySelector(
      '[name="account[sender_email]"]'
    )
    const senderNamePreview = document.querySelector('#sender-name-preview')
    const senderEmailPreview = document.querySelector('#sender-email-preview')

    const preview = function updatePreview() {
      senderNamePreview.innerHTML = senderName.value
      if (senderEmail.value) {
        senderEmailPreview.querySelector('span').innerHTML = senderEmail.value
        senderEmailPreview.style.display = 'inline'
      } else {
        senderEmailPreview.style.display = 'none'
      }
    }

    senderName.addEventListener('keyup', preview)
    senderEmail.addEventListener('keyup', preview)

    preview()
  }
}

document.addEventListener('DOMContentLoaded', previewSender)
